import { useCallback } from 'react';
import { fetchPostData } from '@/Components/hooks/Api';
import { changeArrayFormat } from '@/Components/Common/Utility';

const useReportPendingApproval = ({
  setcheckWebWorkFlowStatus,
  setapproverRequiredCount,
  setGroupList,
  setnarrativeData,
  setApprovedNarrativeData,
  setRejectedNarrativeData,
  setfilteredData,
  setLoginUserGroupList,
  parseAllComments,
}) => {
  // GET_DATA_REPORT_WORK_LEVEL_CHECK
  const GetData_ReportWorkLevelCheck = useCallback((loginAgencyID, narrativeID) => {
    const val = { AgencyID: loginAgencyID, NarrativeID: narrativeID };

    fetchPostData('IncidentNarrativeReport/GetData_ReportWorkLevelCheck', val).then((res) => {
      if (res && res.length > 0) {
        const workflowData = res[0];
        const canShowApprovalButton = workflowData?.IsMultipleLevel;
        setcheckWebWorkFlowStatus(canShowApprovalButton);
        setapproverRequiredCount(workflowData?.ReportApproverRequired);
      }
    });
  }, [setapproverRequiredCount, setcheckWebWorkFlowStatus]);

  // GET_DATA_REPORT_WORK_LEVEL_CHECK_USE_OF_FORCE
  const GetData_ReportWorkLevelCheck_UseOfForce = useCallback((loginAgencyID, useOfForceID) => {
    const val = { AgencyID: loginAgencyID, UseofForceID: useOfForceID };

    fetchPostData('IncidentNarrativeReport/GetData_ReportWorkLevelCheck', val).then((res) => {
      if (res && res.length > 0) {
        const workflowData = res[0];
        const canShowApprovalButton = workflowData?.IsMultipleLevel;
        setcheckWebWorkFlowStatus(canShowApprovalButton);
        setapproverRequiredCount(workflowData?.ReportApproverRequired);
      }
    });
  }, [setapproverRequiredCount, setcheckWebWorkFlowStatus]);

  // GET_GROUP_LIST
  const get_Group_List = useCallback((loginAgencyID, loginPinID, NarrativeID) => {
    const value = { AgencyId: loginAgencyID, PINID: loginPinID, NarrativeID };
    fetchPostData('Group/GetData_Grouplevel', value).then((res) => {
      if (res) {
        setGroupList(changeArrayFormat(res, 'group', 'Level'));
      } else {
        setGroupList();
      }
    });
  }, [setGroupList]);

  // GET_DATA_NARRATIVE
  const get_Data_Narrative = useCallback((NarrativeID, IncidentID) => {
    const val = { NarrativeID, IncidentID };
    fetchPostData('IncidentNarrativeReport/GetNarrativeReportLeftTreeHistory', val).then((res) => {
      if (res) {
        let reportHistory = [];
        try {
          const raw = res[0]?.ReportHistory;
          const parsed = typeof raw === 'string' ? JSON.parse(raw) : (Array.isArray(raw) ? raw : []);
          reportHistory = Array.isArray(parsed) ? parsed : [];
        } catch {
          reportHistory = [];
        }
        const normalizedReports = reportHistory.map((item) => ({
          ...item,
          AllComments: parseAllComments(item?.AllComments),
        }));
        const statusRows = normalizedReports.flatMap((report, reportIndex) => {
          const statusList = Array.isArray(report?.Status) ? report.Status : [];
          return statusList.map((statusItem, statusIndex) => ({
            ...statusItem,
            reportType: report?.reportType,
            WrittenFor_Officer: report?.WrittenFor_Officer,
            Written: report?.Written,
            approverName: report?.approverName,
            historyRowId: `${reportIndex}-${statusIndex}-${statusItem?.Date || ''}`,
          }));
        });
        setnarrativeData(normalizedReports);
        setApprovedNarrativeData([]);
        setRejectedNarrativeData([]);
        setfilteredData(statusRows);
      } else {
        setnarrativeData([]);
        setfilteredData([]);
      }
    });
  }, [parseAllComments, setApprovedNarrativeData, setRejectedNarrativeData, setfilteredData, setnarrativeData]);

  // GET_PERSONNEL_GROUP_DETAILS
  const GetPersonnelGroupDetails = useCallback((PINID, loginAgencyID) => {
    const val = { PINID, AgencyID: loginAgencyID };
    fetchPostData('SecurityGroupUserMembers/GetPersonnelGroupDetails', val).then((res) => {
      if (res) setLoginUserGroupList(res);
      else setLoginUserGroupList([]);
    });
  }, [setLoginUserGroupList]);

  return {
    GetData_ReportWorkLevelCheck,
    GetData_ReportWorkLevelCheck_UseOfForce,
    get_Group_List,
    get_Data_Narrative,
    GetPersonnelGroupDetails,
  };
};

export default useReportPendingApproval;
